import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { DataService } from './data.service';
import { DbService } from './db.service';

@Injectable({
  providedIn: 'root',
})
export class MenuGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private dbService: DbService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const session = await this.authService.getSession();
    if (session?.role !== 'customer') {
      await this.router.navigateByUrl('/barcode', { replaceUrl: true });
      return false;
    }
    try {
      if (!this.dataService.hasMenuFor(session.restaurantId)) {
        await this.dbService.readRestaurantMenu(session.restaurantId);
      }
      return true;
    } catch {
      await this.router.navigateByUrl('/barcode', { replaceUrl: true });
      return false;
    }
  }
}
